import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../../../core/form-generator";
import { getFailedEngineFormConfig } from "./config";
import { Box, Grid, IconButton } from "@mui/material";
import {
  getFileNameFromUrl,
  handleFormValidation,
  PAGE_LIMIT,
} from "../../../../utils";
import SiFileUpload from "../../../../core/file-uploader";
import CustomButtonComponent from "../../../../core/custom-button";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
import InputWithAction from "../../literature/service-information/input-with-action";
import SiAutocomplete from "../../../../core/si-autocomplete";

const CreateFailedEngineAnalysis = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({
    engineModel: [],
    oem: [],
  });
  const [errors, setErrors] = useState({});
  const [oemsList, setOemsList] = useState([]);
  const [files, setFiles] = useState([]);
  const [engineModelList, setEngineModelList] = useState([]);
  const [listNumbers, setListNumber] = useState([]);
  const [approverList, setApproverList] = useState([]);
  const [approver, setApprover] = useState("");
  let oemTimeout = null;

  const resetHandler = () => {
    setFormData({
      engineModel: [],
      oem: [],
    });
    setFiles([]);
    setEngineModelList([]);
    setListNumber([]);
    loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getFailedEngineFormConfig(),
      setErrors,
      formData
    );
    if (isValid) {
      const payload = {
        ...formData,
        oem: formData?.oem?.map((ele) => ele.value),
        engineModel: engineModelList,
        listNo: listNumbers,
        attachments: files?.map((file) => file.url || file) || [],
      };
      if (!editData?.id && !approver) {
        toast.error("Approver is required");
        return;
      }
      if (approver && !editData?.id) {
        payload["qualityApprover"] = approver?.value;
      }
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.FAILED_ENGINE_ANALYSIS}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              setIsCreate(false);
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(
          HTTP_METHODS.POST,
          `${HOSTNAME}${REST_URLS.FAILED_ENGINE_ANALYSIS}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Created Successfully");
              setIsCreate(false);
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const getOemList = (filters) => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemsList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const getApproverList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.USERS}`, null, {
      role: "qualityApprover",
      limit: 100,
    })
      .then((res) => {
        if (res.message) {
          toast.error("Approvers not found");
        } else {
          const result = res.results.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setApproverList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue) => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue), 300);
    }
  };
  useEffect(() => {
    getOemList();
    getApproverList();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      const {
        engineSerialNumber,
        natureOfComplaint,
        defect,
        oem,
        engineModel,
        listNo,
        beforeImprovement,
        afterImprovement,
        cutInEsn,
        cutInEffectiveDate,
        attachments,
        qualityApprover,
      } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        engineSerialNumber,
        natureOfComplaint,
        defect,
        oem: oem?.map((ele) => ({ label: ele?.name, value: ele?.id })),
        beforeImprovement,
        afterImprovement,
        cutInEsn,
        cutInEffectiveDate,
        attachments,
      }));
      setEngineModelList(engineModel);
      setFiles(attachments);
      setListNumber(listNo);
      setApprover(() =>
        approverList?.find((ele) => ele.value === qualityApprover)
      );
    }
  }, [oemsList, approverList]);

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getFailedEngineFormConfig(oemsList, handleRegexSearch)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          fieldGridSize={3}
        />
        <Grid
          container
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            item
            md={5.8}
            sx={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <div
              style={{ width: engineModelList?.length > 0 ? "48%" : "100%" }}
            >
              <p>Engine Model</p>
              <InputWithAction
                updateStateFun={setEngineModelList}
                stateValue={engineModelList}
                placeholder="Enter Engine Model"
              />
            </div>
            {engineModelList?.length > 0 && (
              <div className="input-field-con">
                {engineModelList?.map((engine, index) => {
                  return (
                    <div
                      className={`chip-com-con purple-bg`}
                      style={{ width: "fit-content", marginRight: "1px " }}
                    >
                      <p>{engine} </p>
                      <CloseOutlinedIcon
                        onClick={() => {
                          const filteredList = engineModelList?.filter(
                            (ele) => ele !== engine
                          );
                          setEngineModelList(filteredList);
                        }}
                        fontSize="small"
                        sx={{ ml: 1, cursor: "pointer" }}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </Grid>
          <Grid
            item
            md={5.8}
            sx={{
              display: "flex",
              alignItems: "flex-end",
              mr: 3,
            }}
          >
            <div style={{ width: listNumbers?.length > 0 ? "48%" : "100%" }}>
              <p>List Numbers</p>
              <InputWithAction
                updateStateFun={setListNumber}
                stateValue={listNumbers}
                placeholder="Enter List Number"
              />
            </div>
            {listNumbers?.length > 0 && (
              <div className="input-field-con">
                {listNumbers?.map((list, index) => {
                  return (
                    <div
                      className={`chip-com-con purple-bg`}
                      style={{ width: "fit-content", marginRight: "1px " }}
                    >
                      <p>{list} </p>
                      <CloseOutlinedIcon
                        onClick={() => {
                          const filteredList = listNumbers?.filter(
                            (ele) => ele !== list
                          );
                          setListNumber(filteredList);
                        }}
                        fontSize="small"
                        sx={{ ml: 1, cursor: "pointer" }}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </Grid>
          <Grid container>
            <Grid item md={2.8}>
              <p>Approver*</p>
              <SiAutocomplete
                options={approverList}
                value={approver}
                placeholder="Select Approver"
                disabled={editData?.id}
                onChange={(e) => {
                  if (e?.value) {
                    setApprover(e);
                  } else {
                    setApprover(null);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            mb: 2,
            gridGap: "1rem",
            alignItems: "center",
          }}
        >
          <SiFileUpload id={null} callBack={callBack} />
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px" }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
        {files?.map((r, index) => {
          return (
            <div key={r.blobName + index}>
              {r.blobName ? (
                <span>{r.blobName}</span>
              ) : (
                <a href={r} target="_blank">
                  {getFileNameFromUrl(r)}
                </a>
              )}

              <IconButton onClick={() => onDelete(index)} sx={{ p: 0 }}>
                <CancelOutlinedIcon />
              </IconButton>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CreateFailedEngineAnalysis;
